<ion-content class="showContent">
	<app-main-header></app-main-header>
	<!-- <ion-grid class="max-w-1336 content-box">
		<ion-row>
			<ion-col size="3" class="box-8">
				<ion-card color="primary" [routerLink]="['jobfair']">
					<ion-card-header>
						<ion-card-title>Jobfair</ion-card-title>
					</ion-card-header>
				</ion-card>
			</ion-col>
			<ion-col size="3" class="box-8" [routerLink]="['people']">
				<ion-card color="secondary">
					<ion-card-header>
						<ion-card-title>People</ion-card-title>
					</ion-card-header>
				</ion-card>
			</ion-col>
		</ion-row>
		<ion-row>
			<ion-col size="3" class="box-8" [routerLink]="['company']">
				<ion-card color="success">
					<ion-card-header>
						<ion-card-title>Company</ion-card-title>
					</ion-card-header>
				</ion-card>
			</ion-col>
			<ion-col size="3" class="box-8" [routerLink]="['serverless']">
				<ion-card color="danger">
					<ion-card-header>
						<ion-card-title>Serverless</ion-card-title>
					</ion-card-header>
				</ion-card>
			</ion-col>
		</ion-row> -->

	<!-- <cdk-virtual-scroll-viewport
					class="ion-content-scroll-host"
					itemSize="10"
				>
					
				</cdk-virtual-scroll-viewport> -->
	<!-- </ion-grid>  -->

	<router-outlet></router-outlet>
</ion-content>
<ion-content class="showBox">
	<ion-grid
		class="background-Blues-Default_Blue h-100 flex justify-center items-center px-16"
	>
		<ion-row class="box px-16">
			<ion-col size="12" class="mb-8 Heading_L"> Hi there! </ion-col>
			<ion-col size="12" class="Body_M">
				We’ve built this experience for larger devices. Please open from a
				laptop or PC.
			</ion-col>
		</ion-row>
	</ion-grid>
</ion-content>
